import {LinearProgress, LinearProgressProps} from '@mui/material';
import {extend} from 'lodash';
import React from 'react';
export interface ApplinearLoaderProps extends LinearProgressProps {}
export const ApplinearLoader: React.FC<ApplinearLoaderProps> = ({...props}) => {
    return <LinearProgress color="primary" sx={{height: 2}} {...props} />;
};

export default ApplinearLoader;
